import { Col, Row } from 'festo-react-ui-kit';
import React, { useState } from 'react';
import useFoXHeadline from './useFoxHeadline';
import { useTranslation } from '../../hooks/useTranslation';
import ShareLink from '../ShareLink/ShareLink';
import '../Headline/Headline.scss';
import Breadcrumbs from '../Breadcrumb/Breadcrumbs';
import { RequestHandler } from '../../app/RequestHandler';

enum TranslationKeys {
  HEADLINE = 'headline',
  SUBHEADING = 'headlineFirstSentence',
  SHOW_MORE = 'showMore',
  SHOW_LESS = 'showLess',
}

function Headline(): JSX.Element {
  const t = useTranslation();
  const { hasFoXHeadline } = useFoXHeadline();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const { applicationType } = new RequestHandler();
  const isStandalone = applicationType === 'standalone';

  return (
    <div className="headline container-fluid content-copy">
      {isStandalone ? null : <Breadcrumbs />}
      <Row>
        <Col xs={12}>
          {hasFoXHeadline ? null : (
            <h1 className="main-headline fwe-d-flex">
              <span>{t(TranslationKeys.HEADLINE)}</span>
              <ShareLink />
            </h1>
          )}

          {hasFoXHeadline ? (
            <div data-testid="headline-links" className="ems-headline__links--desktop">
              <ShareLink />
            </div>
          ) : null}

          {hasFoXHeadline ? null : (
            <div className="subHeadingText-container">
              <p id="subHeadingText" className={`copytext content-copy__copytext ${isCollapsed ? 'collapsed' : ''}`}>
                {t(TranslationKeys.SUBHEADING)}
              </p>
              <span id="show-more" onClick={() => setIsCollapsed(!isCollapsed)}>
                {isCollapsed ? t(TranslationKeys.SHOW_MORE) : t(TranslationKeys.SHOW_LESS)}
              </span>
            </div>
          )}
        </Col>
      </Row>
    </div>
  );
}

export default Headline;
